<template>
  <div>
    <div class="text-h6">
      Go to your text messages
    </div>
    <p>
      Enter the 6-digit code that was sent to your phone via text message.
    </p>
    <form @submit.prevent="submitCode">
      <q-input v-model="code" maxlength="6" outlined autofocus />
      <resend-code-btn
        :session-id="sessionId"
        :result="result"
        class="q-my-md"
        @result="$emit('result', $event)"
      />
      <message v-if="result.error" type="negative" class="q-mt-md">
        {{ result.error }}
      </message>
      <div class="text-center q-my-md">
        <async-btn
          :task="task"
          type="submit"
          label="Continue"
          color="primary"
          class="full-width"
          rounded
        />
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import Message from '@/components/message/Message.vue';
import { submitSmsAuthCode, LoginResult } from '.';
import ResendCodeBtn from './ResendCodeBtn.vue';

interface Data {
  code: string,
  task: Promise<LoginResult>|null,
}

export default defineComponent({
  emits: ['error', 'result'],
  components: { Message, AsyncBtn, ResendCodeBtn },
  mixins: [HasTaskMixin],
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
  data(): Data {
    return {
      code: '',
      task: null,
    };
  },
  methods: {
    submitCode() {
      this.task = submitSmsAuthCode(this.sessionId, this.code);
      this.task.then((result) => {
        this.$emit('result', result);
      });
      this.task.catch(() => {
        this.$emit('error');
      });
    },
  },
});
</script>
